










import { Component, Prop, Vue } from 'vue-property-decorator';
import TextAlignPicker from '@/components/text-align/index.vue';
import PopField from '../PopField/index.vue';

@Component({ components: { PopField, 'text-align-picker': TextAlignPicker } })
export default class AlignField extends Vue {
  @Prop({ type: String, default: 'left' }) value!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: '' }) col!: string;
}
